import React from "react"

import "./Divider.scss"

const Divider = () => {
  return <div className="divider" />
}

export default Divider
